import CardsList from "@/components/cardsList";
import { NAVIGATION_CARDS_CONSTANTS } from "./navigationCardsConstants";

const NavigationCards = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 2, md: 3 }}
      list={NAVIGATION_CARDS_CONSTANTS.list}
      hoverEffect={NAVIGATION_CARDS_CONSTANTS.hoverEffect}
      spacing={{ base: 8, md: 12 }}
    />
  );
};

export default NavigationCards;
